var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"color":'#f57c00',"app":""}},[_c('div',{staticClass:"wrapper d-flex justify-center"},[_c('v-img',{attrs:{"src":require("@/assets/w-brand.png"),"max-height":"150","max-width":"150","contain":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }